import React, { useEffect, useState, useRef } from 'react';
import Footer from '../layout/footer/footer';
import './home.css';
import { Virtual, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Skeleton } from 'primereact/skeleton';

import Carousel from 'react-bootstrap/Carousel';
import Banner from '../assets/images/banner.jfif';
import BtnBg from '../assets/images/btn-bg.svg';
import Img from '../assets/images/img.jfif';
import Img2 from '../assets/images/img2.jpg';
import Img3 from '../assets/images/img3.jfif';
import ArrowLeft from '../assets/icons/arrow-left.svg';
import Phone from '../assets/icons/phone.svg';
import Cake from '../assets/icons/cake.svg';
import Ranking from '../assets/icons/ranking.svg';
import Medal from '../assets/images/medal.svg';
import LogoWhite from '../assets/images/logo-shadow.svg';
import Task from '../assets/icons/task.svg';
import Security from '../assets/icons/security.svg';
import { TabView, TabPanel } from 'primereact/tabview';
import ProductsItem from '../components/productsItem1/products-items';
import Blogs from '../components/blogs/blogs';
import ProductAnimation from '../components/product-animation/productAnimation';
import CustomerList from '../components/customer-list/customerList';
import ContactUsComponent from '../components/contact-us-component/contact-us';
import { Form } from 'react-bootstrap';
import { baseUrl, imgBaseUrl, getCategory, getFoundUs, SearchBanner, imgBaseUrl2, getCustomer, getProductsBySearch, getBlogsAndNewsBySearch } from '../utils/api';
import Loader from '../components/loader/dotloader'
import CarouselList from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import GifImage from '../assets/images/gif-img.mp4'
import SliderWeb from './home/slider';
import CategorySlider from '../components/category-slider/cat-slider'
import ProductImage from '../assets/images/defult-img.svg';

function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeBlogIndex, setActiveBlogIndex] = useState(0);
  const [swiperRef, setSwiperRef] = useState(null);
  const [categories, setCategory] = useState([]);
  const [foundUs, setFoundUs] = useState([]);
  const [firstHalf, setFirstHalf] = useState([]);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [loadingBlog, setLoadingBlog] = useState(false);
  const [secondHalf, setSecondHalf] = useState([]);
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [bannerImg, setBannerImg] = useState([]);
  const [contactUsImage, setContactUsImage] = useState([]);
  const [customers, setCustomer] = useState([]);
  const [productsItem, setProductsItem] = useState([]);
  const [imageProductRandom, setImageProductRandom] = useState([]);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getCustomer(pay);
        setCustomer(res.data.data.items);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchCustomer();
  }, []);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  const fetchProducts = async () => {
    try {
      const pay = { pageSize: 0, pageIndex: 0 };
      const res = await getProductsBySearch(pay);
      console.log('resss', res)
      setProductsItem(res.data.data.items);
      console.log(res.data.data.items)
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const loadPage = async () => {
    try {
      SearchBanner({ slug: 'home2' }).then(response => {
        if (response.data) {
          setBannerImg(response.data.data);

        }
      })
    } catch (error) { }
  };
  const contactusBanner = async () => {
    try {
      SearchBanner({ slug: 'contactUsImage' }).then(response => {
        if (response.data) {
          setContactUsImage(response.data.data);

        }
      })
    } catch (error) { }
  };
  // Fetch categories and split them into two halves
  useEffect(() => {
    loadPage()
    contactusBanner()
    const fetchCategories = async () => {
      try {
        setLoading(true)
        const pay = { pageSize: 20, pageIndex: 0 };
        const res = await getCategory(pay);
        const items = res.data.data.items;
        setLoading(false)
        const list = items.filter(product => product.isActive && product.showInLandingPage)
        setCategory(list);

        // Split the items array into two equal parts
        const midpoint = Math.ceil(list.length / 2);
        setFirstHalf(list.slice(0, midpoint));
        setSecondHalf(list.slice(midpoint));
      } catch (error) {
        setLoading(false)
        console.error('Error fetching products:', error);
      }
    };
    fetchCategories();


  }, []);

  const mobileBanners = bannerImg.filter(img => img.useFor === 2);
  const webBanners = bannerImg.filter(img => img.useFor === 1);


  useEffect(() => {
    const fetchFoundUs = async () => {
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getFoundUs(pay);
        const items = res.data.data.items;
        setFoundUs(items);

      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchFoundUs();
  }, []);



  const getRandomItems = (array, count) => {
    console.log(array)
    const result = [];
    const usedIndices = new Set();

    while (result.length < count && usedIndices.size < array.length) {
      const randomIndex = Math.floor(Math.random() * array.length);
      if (!usedIndices.has(randomIndex)) {
        usedIndices.add(randomIndex);
        result.push(array[randomIndex]);
      }
    }

    return result;
  };


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const pay = { pageSize: 2000, pageIndex: 0 };
        const res = await getProductsBySearch(pay);
        console.log('res', res);

        const items = res.data.data.items;

        setProductsItem(items);
        if (items.length >= 3) {
          const selectedItems = getRandomItems(items, 3);
          setImageProductRandom(selectedItems);
        }

      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);



  const videoRefs = useRef([]);

  const handleSlide = (eventKey) => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === eventKey) {
          video.currentTime = 0; // بازنشانی زمان ویدیو
          video.play(); // پخش مجدد ویدیو
        } else {
          video.pause(); // توقف ویدیوهای دیگر
        }
      }
    });
  };
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [lastMoveTime, setLastMoveTime] = useState(0);

  // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = throttle((e) => {
    if (!isDragging) return;

    setCurrentX(e.clientX);
  }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

  const handleMouseUp = () => {
    setIsDragging(false);
    const deltaX = currentX - startX;

    if (deltaX > 50) {
      if (carouselRef.current) {
        carouselRef.current.prev(); // اسلاید قبلی

      }
    } else if (deltaX < -50) {
      if (carouselRef.current) {
        carouselRef.current.next(); // اسلاید بعدی
      }
    }

    // ریست مقادیر
    setStartX(0);
    setCurrentX(0);
  };
  function convertToPersianNumbers(input) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return input.replace(/\d/g, (digit) => persianDigits[digit]);
  }

  useEffect(() => {
    // به محض تغییر تب، فرض کنید که بعد از 1 ثانیه محصولات بارگذاری می‌شوند
    const timer = setTimeout(() => {
      setLoadingProduct(false); // پس از بارگذاری محصولات، لودینگ را غیرفعال کنید
    }, 200);

    return () => clearTimeout(timer); // زمان را پاک کنید
  }, [activeIndex]);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getBlogsAndNewsBySearch(pay);
        if (res.data.isSuccess) {
          setBlogs(res.data.data.items);

        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false); // توقف لودینگ
      }
    };
    fetchBlogs();
  }, []);
  const renderHtml = (rowData) => {
    const textContent = rowData.replace(/<[^>]+>/g, ''); // حذف تگ‌های HTML
    return (
        <div
            style={{
               fontSize: '17px',
               fontWeight: '600',
               fontFamily: 'yekan-bakh-medium',
              //  color : '#4f5255'

            }}
            title={textContent} // نمایش متن کامل در tooltip
        >
            {textContent}
        </div>
    );
};

  useEffect(() => {
    // به محض تغییر تب، فرض کنید که بعد از 1 ثانیه محصولات بارگذاری می‌شوند
    const timer = setTimeout(() => {
      setLoadingBlog(false); // پس از بارگذاری محصولات، لودینگ را غیرفعال کنید
    }, 200);

    return () => clearTimeout(timer); // زمان را پاک کنید
  }, [activeBlogIndex]);
  return (
    <>
      {loading && <Loader isLoading={loading} />}
      {/* top-mobile  */}


      <div className='slider mobile-slider'>

        <Carousel interval={10000} controls={false} indicators={bannerImg.filter((item) => item.useFor === 2).length > 1}
        >
          {bannerImg.length && bannerImg
            .filter(item => item.useFor === 2)
            .sort((a, b) => a.number - b.number) // مرتب‌سازی بر اساس number
            .map(item => (
              <Carousel.Item>
                {item.typeId == 2 ? (
                  <div className="img-slider ">
                    <video
                      muted
                      ref={(el) => (videoRefs.current[index] = el)}
                      loop
                      style={{ width: '100%' }}

                    >
                      <source src={`${imgBaseUrl2}io/${item.filePath}`} type="video/mp4" />
                    </video>
                  </div>
                ) : (
                  <img
                    src={`${imgBaseUrl2}io/${item.filePath}`}
                    className="img-slider"
                    alt=""
                  />
                )}
                {item.isDefault &&
                  <Carousel.Caption >
                    <h3><span className='text-5xl font-bold'>طبیعی باش</span><span className='text-2xl font-medium'>، با لذت بنوشید ...</span></h3>
                    <div className='d-flex align-items-center gap-2 mt-2'>
                      <button className='btn btn-primary d-flex align-items-center gap-2 text-sm py-2' onClick={() => { window.location.href = '/shop' }}>فروشگاه</button>
                      <button className='btn btn-outline-primary d-flex align-items-center gap-2 text-sm py-2' onClick={() => { window.location.href = '/products' }}>مشاهده محصولات<img src={ArrowLeft} alt="" /></button>

                    </div>
                  </Carousel.Caption>
                }

              </Carousel.Item>
            ))}


        </Carousel>
      </div>

      <div className='home-container'>

        <div className="">
          <div className='slider web-slider container px-0'>
            <SliderWeb bannerImg={bannerImg} imgBaseUrl2={imgBaseUrl2} />

            <div className='feature align-items-center justify-content-between'>
              <div className='feature-left'></div>
              <div className='feature-right'></div>
              <div className='text-center'>
                <img className='mx-auto' src={Ranking} alt="" />
                <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>دست ساز با بهترین مواد اولیه</h6>
              </div>
              <div className='text-center'>
                <img className='mx-auto' src={Task} alt="" />
                <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>ارگانیک دارای گواهی USDA</h6>
              </div>
              <div className='text-center'>
                <img className='mx-auto' src={Security} alt="" />
                <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>امن برای شما و خانواده شما</h6>
              </div>
            </div>
            <div className='products d-flex align-items-center justify-content-between' onClick={() => { window.location.href = `/products?categoryId=` }}>
              <h6 className='font-semibold text-base text-[#3E3E3E]'>{convertToPersianNumbers('+100 نوع محصول')}</h6>
              <h6 className='font-semibold text-base plus-text'>{convertToPersianNumbers('+100')}</h6>
              <div className='d-flex align-items-center justify-content-center'>
                {imageProductRandom && imageProductRandom.slice(0, 3).map(product =>
                  product && product.images && product.images.slice(0, 3).map((item, index) => (
                    <img src={item && item.url ? imgBaseUrl2 + 'io/54x54/' + item.url : Img} alt="" className='one' />
                  ))
                )}


              </div>
            </div>
          </div>

          <div style={bannerImg.length && bannerImg
            .filter(item => item.useFor === 2).length > 0 ? { marginTop: '0.25em' } : { marginTop: '4em' }} className='feature-mobile container  d-flex align-items-center justify-content-between gap-1'>

            <div className='text-center'>
              <img className='mx-auto' src={Ranking} alt="" width={16} />
              <h6 className='mt-2  font-bold' style={{ fontSize: '12px' }}>بهترین کیفیت مواد اولیه</h6>
            </div>
            <div className='text-center'>
              <img className='mx-auto' src={Task} alt="" width={16} />
              <h6 className='mt-2  font-bold' style={{ fontSize: '12px' }}>ارگانیک دارای گواهی USDA</h6>
            </div>
            <div className='text-center'>
              <img className='mx-auto' src={Security} alt="" width={16} />
              <h6 className='mt-2  font-bold' style={{ fontSize: '12px' }}>سالم برای خانواده شما</h6>
            </div>
          </div>


          {/* products */}
          <section className='' style={{ position: 'relative', marginTop: '3em' }}>
            <div className='tab-home mt-2 '>
              <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align mb-2 container' >
                <h5 className='text-3xl section-title font-bold leading-10 title-margin' style={{ borderBottom: '2px solid #00A14B', marginRight: '40px' }}>محصولات ما</h5>
                <div className="flex gap-2 justify-content-center tab-btn">
                  <button onClick={() => { setActiveIndex(0); setLoadingProduct(true) }} className={activeIndex !== 0 ? 'btn' : 'btn tab-active'} >همه محصولات</button>
                  <button onClick={() => { setActiveIndex(1); setLoadingProduct(true) }} className={activeIndex !== 1 ? 'btn' : 'btn tab-active'}>محبوب ترین ها</button>
                  <button onClick={() => { setActiveIndex(2); setLoadingProduct(true) }} className={activeIndex !== 2 ? 'btn' : 'btn tab-active'}>جدیدترین ها</button>
                </div>
              </div>
              {/* اسکلتون در هنگام بارگذاری محصولات */}
              {loadingProduct ? (
                <div className=''>

                  <div className="skeleton-wrapper py-4 container d-flex align-items-center justify-content-between web-selekton">
                    {[...Array(4)].map((_, index) => (
                      <div className="product-item" style={{ width: '300px' }}>
                        <div className="product-img">
                          <Skeleton className="img-box img-product h-100" />
                        </div>
                        <div className="detail">
                          <Skeleton className="mt-4" />
                          <Skeleton className="mt-2" />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="skeleton-wrapper container d-flex gap-2 align-items-center justify-content-between mobile-selekton">
                    {[...Array(2)].map((_, index) => (
                      <div className="product-item" style={{ width: '250px' }}>
                        <div className="product-img">
                          <Skeleton className="img-box img-product h-100" />
                        </div>
                        <div className="detail">
                          <Skeleton className="mt-4" />
                          <Skeleton className="mt-2" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className='container tab-contain'>
                  <TabPanel>
                    <ProductsItem productCat='all' products={productsItem} />
                  </TabPanel>
                  <TabPanel>
                    <ProductsItem productCat='isFavorit' products={productsItem} />
                  </TabPanel>
                  <TabPanel>
                    <ProductsItem productCat='isNew' products={productsItem} />
                  </TabPanel>
                </TabView>
              )
              }
            </div>
          </section>

          <section className='mt-2 container mobile-container'>
            <div className='more-info  mx-0 bg-[#d1e6d2] rounded-[42px] d-flex align-items-center justify-content-between gap-5'>
              <div>
                <h5 className='text-2xl font-bold'><span className='text-[#00A14B] text-3xl font-bold'>طبیعی باش</span> (بن آیس) را بیشتر بشناسید
                </h5>
                {foundUs.map((item, index) => (
                  <div  key={index}>
                       <div className='mt-3 body-item text-[#494C50] text-base fw-500 font-medium ' dangerouslySetInnerHTML={{ __html: item.title}} />

                  </div>
                ))}


              </div>
              <div className='d-flex align-items-center gap-3'>
                <div className='relative'>
                  <div className='img-box'>
                    <img
                      className='rounded-2xl'
                      src={
                        foundUs &&
                          foundUs[0] &&
                          foundUs[0].images &&
                          foundUs[0].images[0] &&
                          foundUs[0].images[0].url
                          ? imgBaseUrl2 + 'io/' + foundUs[0].images[0].url
                          : ''
                      }
                      alt=""
                    />

                  </div>
                  <div className='medal-box rounded-2xl'>
                    <div className='medal-img-bottom'></div>
                    <div className='medal-img-top'></div>
                    <div className='medal-img'>
                      <img className='rounded-2xl' src={Medal} alt="" />

                    </div>
                  </div>
                </div>
                <div className='img-box'>
                  <img
                    className='rounded-2xl'
                    src={
                      foundUs &&
                        foundUs[0] &&
                        foundUs[0].images &&
                        foundUs[0].images[1] &&
                        foundUs[0].images[1].url
                        ? imgBaseUrl2 + 'io/' + foundUs[0].images[1].url
                        : ''
                    }
                    alt=""
                  />

                </div>
              </div>
            </div>
          </section>
          <section id='myProductSection' className='mt-5'>
            <div className=''>
              <div className='container'>

                <span className='text-2xl font-bold leading-10  mr-3 title-margin' style={{ borderBottom: '2px solid #00A14B', marginRight: '40px' }}>تنوع محصولات ما</span>
              </div>
              <div className='d-flex align-items-center justify-content-center container gap-5 my-product web-category'>
                <div className='d-flex flex-column align-items-stretch justify-content-between gap-4'>
                  {firstHalf.map((item, index) => (
                    <div key={index} className="button-item first-group" onClick={() => { window.location.href = `/products?categoryId=${item.id}` }}>
                      <button className='btn'>
                        <img src={imgBaseUrl + item.logoPath} alt="" width={24} />
                        <span className='flex-1 text-center'>{item.title}</span>
                      </button>
                    </div>
                  ))}
                </div>


                {/* ProductAnimation */}
                <ProductAnimation />
                <div className='d-flex flex-column align-items-stretch my-5 justify-content-end gap-4' style={{ marginRight: '5em' }}>
                  {/* نمایش 5 دکمه باقی‌مانده */}
                  {secondHalf.map((item, index) => (
                    <div key={index} className="button-item second-group" onClick={() => { window.location.href = `/products?categoryId=${item.id}` }}>
                      <button className='btn'>
                        <img src={imgBaseUrl + item.logoPath} alt="" width={24} />
                        <span className='flex-1 text-center '>{item.title}</span>
                      </button>
                    </div>
                  ))}
                </div>

              </div>




              {/* mobile  */}
              <div className='mobile-category text-center my-product mt-5'>
                {/* ProductAnimation */}
                <ProductAnimation className="mx-auto" />
                <CategorySlider categories={categories} />
                {/* <Swiper
                  modules={[Virtual, Navigation, Pagination]}
                  onSwiper={setSwiperRef}
                  breakpoints={{
                    300: { slidesPerView: 4, spaceBetween: 20 },
                    640: { slidesPerView: 4, spaceBetween: 20 },
                    768: { slidesPerView: 5, spaceBetween: 20 },
                    1200: { slidesPerView: 5, spaceBetween: 50 },
                  }}
                  navigation={true}
                  virtual
                  dir='rtl'
                  loop
                  spaceBetween={10}

                >
                  {categories.map((item, index) => (
                    <SwiperSlide key={item.id} virtualIndex={index}>
                      <div key={index} className="button-item first-group mb-2">
                        <button className='btn d-flex align-items-center gap-2'>
                          <img src={imgBaseUrl + item.logoPath} alt="" width={24} />
                          {item.title}
                        </button>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper> */}


              </div>

            </div>

          </section>



          {/* contact us */}
          {/* <section className='mt-5 container'>
            <div className='more-info contact-us mx-0 bg-[#d1e6d2] flex-mob-col  rounded-[42px] d-flex align-items-center justify-content-between gap-5'>

              <div className='w-3/5	max-sm:!w-full'>
                <span className='text-2xl font-bold leading-10' style={{ borderBottom: '2px solid #00A14B' }}>امور مشتریان</span>
                <div>
                  <ContactUsComponent />

                </div>

              </div>
              <div className='d-flex align-items-center gap-3 ml-4'>
                <div className='relative'>
                  <img src={LogoWhite} alt="" className='logo-box' style={{ position: 'absolute', top: '-3em', left: '-3em' }} />
                  <div className='img-box'>
                    <img
                      className='rounded-3xl'
                      src={
                        contactUsImage.length &&
                          contactUsImage[0] &&
                          contactUsImage[0].filePath
                          ? `${imgBaseUrl2}io/${contactUsImage[0].filePath}`
                          : Img
                      }
                      alt=""
                    />

                  </div>
                  <div className='medal-box rounded-3xl'>
                    <div className='medal-img-bottom'></div>
                    <div className='medal-img-top'></div>
                    <div className='medal-img'>
                      <img className='rounded-3xl' src={Phone} alt="" />

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section> */}

          {/* blogs */}
          <section style={{ position: 'relative' }}>
            <div className='tab-home blog-items mt-5 '>
              <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align mb-2 container'>
                <h5 className='text-3xl section-title font-bold leading-10 title-margin' style={{ borderBottom: '2px solid #00A14B', marginRight: '40px' }}>{activeBlogIndex == 0 ? 'بلاگ ها و اخبار طبیعی باش' :
                  activeBlogIndex == 1 ? 'اخبار طبیعی باش' :
                    activeBlogIndex == 2 ? 'بلاگ ها' :
                      ''}</h5>
                <div className="flex gap-2 justify-content-center justify-content-center tab-btn">
                  <button onClick={(e) => { e.preventDefault(); setActiveBlogIndex(0); setLoadingBlog(true) }} className={activeBlogIndex !== 0 ? 'btn' : 'btn tab-active'} >همه</button>
                  <button onClick={(e) => { e.preventDefault(); setActiveBlogIndex(1); setLoadingBlog(true) }} className={activeBlogIndex !== 1 ? 'btn tab-new' : 'btn tab-active tab-new'}>اخبار طبیعی باش</button>
                  <button onClick={(e) => { e.preventDefault(); setActiveBlogIndex(2); setLoadingBlog(true) }} className={activeBlogIndex !== 2 ? 'btn' : 'btn tab-active'}>بلاگ ها</button>
                </div>
              </div>
              {loadingBlog ? (
                <div className='py-4'>

                  <div className="skeleton-wrapper container d-flex align-items-center justify-content-between ">
                    {[...Array(4)].map((_, index) => (
                      <div className="product-item" style={{ width: '300px' }}>
                        <div className="product-img">
                          <Skeleton className="img-box img-product h-100" />
                        </div>
                        <div className="detail">
                          <Skeleton className="mt-4" />
                          <Skeleton className="mt-2" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <TabView activeIndex={activeBlogIndex} onTabChange={(e) => setActiveBlogIndex(e.index)} className='container tab-contain'>

                  <TabPanel>
                    <Blogs type='all' products={blogs} />
                  </TabPanel>
                  <TabPanel>
                    <Blogs type='2' products={blogs} />
                  </TabPanel>
                  <TabPanel>
                    <Blogs type='1' products={blogs} />
                  </TabPanel>

                </TabView>
              )}
            </div>

          </section>
          {customers && customers.length > 0 &&
            <section className='mt-10'>
              <div className='customers  bg-[#d1e6d2] py-2 rounded-[134px] row gy-1'>
                <div className=' col-sm-12 col-md-6 col-lg-6 d-flex align-items-center px-1'>
                  <h5 className='text-3xl section-title font-bold leading-10 customer-title' style={{ borderBottom: '2px solid #00A14B', marginRight: '18px' }}>مشتریان ما</h5>

                </div>

                <div className=' col-sm-12 col-md-6 col-lg-6 '>
                  <CustomerList />

                </div>
              </div>
            </section>
          }

        </div>
      </div>
    </>
  );
}

export default Home;
